import { ComponentConfig } from "@measured/puck"
import { Button, DatePicker, message, Modal, Select } from "antd"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import {
  configs,
  DefaultImage,
  fetchCategories,
  filterOption,
  Media,
  MediaUpload,
} from "../../../../external-components"
import { Pagination } from "../../../types"
import { ArticlesProps, RenderConfig } from "./RenderConfig"

const ImageCard = ({ value, onChange, label }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)
  const [url, setUrl] = useState(value)

  const openModal = () => {
    setIsModalOpen(true)
  }

  const handleSelectMedia = (media: { url: string }) => {
    setUrl(media.url)
    onChange(media.url)
    setIsModalOpen(false)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div>
      <label className="font-bold text-sm mb-2">{label}</label>
      <div className="flex flex-col gap-2">
        <input type="text" value={url} onChange={e => onChange(e.target.value)} placeholder="Image URL" readOnly />
        <div className="relative cursor-pointer group" onClick={() => openModal()}>
          <img
            src={url ? `${configs.API_URL}${url}` : DefaultImage}
            alt="Slider Image"
            className="rounded-lg max-h-96 cursor-pointer transition duration-300 ease-in-out group-hover:blur-sm overflow-hidden"
          />
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 ease-in-out">
            <span className="text-white text-3xl font-semibold drop-shadow-md">Change media</span>
          </div>
        </div>

        <Button
          onClick={() => openModal()}
          type="default"
          variant="outlined"
          className="bg-blue text-white p-4 border-[1px] border-blue rounded-[3px] hover:bg-blue-800 hover:text-white duration-300 my-2"
        >
          Select Image
        </Button>
      </div>

      <Modal
        open={isModalOpen}
        title={<span className="ml-4">Select Media</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div className="ml-4 mt-5">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{
              backgroundColor: isChooseMedia ? "blue" : "initial",
              color: isChooseMedia ? "white" : "initial",
            }}
          >
            Select Media
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            Upload Media
          </Button>
        </div>

        <div>
          {isChooseMedia ? (
            <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
          ) : (
            <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}
const SelectCategory = ({ value, onChange }: any) => {
  const [optionCategories, setOptionCategories] = useState<{ value: string; label: string }[]>([])

  const fetchCategory = async (paginate?: Pagination, searchTerm?: string) => {
    try {
      const response = await fetchCategories(searchTerm, "undefined")

      setOptionCategories(
        (response as { data: { id: string; attributes: { name: string } }[] }).data.map(
          (category: { id: string; attributes: { name: string } }) => ({
            value: category.id as string,
            label: category.attributes.name,
          }),
        ),
      )
    } catch (err) {
      message.error("Failed to fetch categories. Please try again.")
    }
  }

  useEffect(() => {
    fetchCategory()
  }, [])
  const handleChange = async (selectedValue: string) => {
    try {
      // const selectedCategory = optionCategories.find(category => category.value === selectedValue)
      onChange(selectedValue)
    } catch (error) {
      console.error("Error fetching posts by category:", error)
    }
  }

  return (
    <Select
      showSearch
      style={{ minWidth: "14rem" }}
      placeholder="Select Category"
      optionFilterProp="children"
      filterOption={filterOption}
      options={optionCategories}
      allowClear
      value={value}
      onChange={handleChange}
    />
  )
}

export const ArticlesItemsList: ComponentConfig<ArticlesProps> = {
  label: "CaoCao | Articles List",
  //@ts-ignore
  fields: {
    gapCustom: {
      label: "Gap",
      type: "text",
    },
    heightContact: {
      label: "Heigth of Contact",
      type: "text",
    },
    category: {
      label: "Category",
      type: "custom",
      render: props => <SelectCategory {...props} />,
    },
    articleItem: {
      label: "Contact Items",
      type: "array",
      arrayFields: {
        image1: {
          label: "Image",
          type: "custom",
          render: props => <ImageCard {...props} />,
        },
        image2: {
          label: "Image",
          type: "custom",
          render: props => <ImageCard {...props} />,
        },
        time: {
          label: "Time",
          type: "custom",
          render: ({ value, onChange }: any) => {
            const parsedValue = value ? dayjs(value) : null

            return (
              <DatePicker
                value={parsedValue}
                onChange={date => {
                  const isoDate = date ? date.toISOString() : null
                  console.log("Selected Date (ISO):", isoDate)
                  onChange(isoDate)
                }}
                format="YYYY-MM-DD"
              />
            )
          },
        },

        itemTitle: {
          label: "Item Title",
          type: "text",
        },
        excerpt: {
          label: "Item Content",
          type: "text",
        },
      },
    },
    type: {
      label: "Layout Type",
      type: "select",
      options: [
        { label: "Fluid", value: "fluid" },
        { label: "Custom", value: "custom" },
        { label: "Boxed", value: "boxed" },
      ],
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    gapCustom: "83px",
    heightContact: "388px",
    articleItem: [
      {
        image1: "",
        image2: "",
        itemTitle: "Item 1 Title",
        excerpt: "Item 1 Content",
      },
      {
        image1: "",
        image2: "",
        itemTitle: "Item 2 Title",
        excerpt: "Item 2 Content",
      },
    ],
    type: "fluid",
    className: "",
  },
  ...RenderConfig,
}
